<template>
  <div class="view pa24">
    <el-dialog title="绑定经销商" width="600px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :before-close="close">
      <el-form ref="elForm" :model="ruleForm" label-width="120px" :inline="true">
        <el-form-item label="选择经销商：" prop="supplierId">
          <el-select v-model="ruleForm.supplierId" value-key placeholder="请选择">
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="dialog-footer" style="text-align: right">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" class="btncss" @click="confirm">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getDealerListApi, bindDealerApi } from "@/api/boomClass.js";
  export default {
    name: "",
    components: {},
    props: [],
    data() {
      return {
        dialogVisible: false,
        ruleForm: {
          excleId: "",
          excleIdDetail: "",
          supplierId: "",
        },
        supplierList: [],
      };
    },
    mounted() { },
    methods: {
      close() {
        this.$refs.elForm.resetFields();
        this.dialogVisible = false;
      },
      open(item) {
        console.log(item);
        this.ruleForm.excleId = item.detailId;
        this.ruleForm.excleIdDetail = item.id;
        this.dialogVisible = true;
        this.getDealerList();
      },
      getDealerList() {
        let params = {
          excleId: this.ruleForm.excleId,
        };
        getDealerListApi(params).then((res) => {
          if (res.code == 200) {
            this.supplierList = res.data;
          }
        });
      },
      confirm() {
        const { supplierId } = this.ruleForm;
        if (!supplierId) {
          this.$message.error("请选择经销商");
          return;
        }
        let params = {
          supplierId: supplierId,
          excleId: this.ruleForm.excleIdDetail,
          // ...this.ruleForm,
        };
        bindDealerApi(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "绑定成功",
              type: "success",
            });
            this.$emit("success");
            this.close();
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>